import ValidationStates from '../../tc-component-helpers/src/ValidationConstants.js';

var validatable = {
  props: {
    validationState: {
      type: String,
      default: 'NoValidate'
    },
    validationMessage: {
      type: String
    }
  },
  computed: {
    valid: function valid() {
      return this.validationState === ValidationStates.Valid
    },
    invalid: function invalid() {
      return this.validationState === ValidationStates.Invalid
    },
    pending: function pending() {
      return this.validationState === ValidationStates.Pending
    }
  }
};

export default validatable;
